import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=4f1c3380&"
import script from "./HotelDetails.vue?vue&type=script&lang=js&"
export * from "./HotelDetails.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
